import { defineStore } from "pinia"
import axios from "axios"

export const useUsersStore = defineStore("users", {
  state: () => ({
    users: [] as App.Models.User[],
    loaded: false,
    inFlight: null as Promise<App.Models.User[]> | null,
  }),
  actions: {
    async loadUsers(force = false): Promise<App.Models.User[]> {
      if (this.loaded && !force) return this.users
      if (this.inFlight && !force) return this.inFlight

      this.inFlight = (async () => {
        const { data: { data } } = await axios.get("/users", {
          params: { itemsPerPage: -1 }
        })
        this.users = data
        this.loaded = true
        return data
      })()

      try {
        return await this.inFlight
      } finally {
        this.inFlight = null
      }
    },
    reset() {
      this.users = []
      this.loaded = false
      this.inFlight = null
    },
  },
})
